import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailDataTableRepository from '../Repositories/DetailDataTableRepository'


class DetailDataTableBloc {

    detailRowtableChannel = new Subject();
    // detailInactiveChannel = new Subject();
    // detailActiveChannel = new Subject();
    repository = new DetailDataTableRepository()

    constructor() {
        this.detailRowtableChannel.next({status: apiResponse.INITIAL})
        // this.detailInactiveChannel.next({status: apiResponse.INITIAL})
        // this.detailInactiveChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetailRowTable = async (query, cancelToken) => {
        this.detailRowtableChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchDetailRowTable(query, cancelToken).then((result) => {
                this.detailRowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailRowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    // fetchInactive = async (query) => {
    //     this.detailInactiveChannel.next({status: apiResponse.LOADING})
    //     try {
    //         await this.repository.fetchInactive(query).then((result) => {
    //             this.detailInactiveChannel.next({status: apiResponse.COMPLETED, data: result})
    //         }).catch((error) => {
    //             this.detailInactiveChannel.next({status: apiResponse.ERROR, data: error})
    //         })           
    //     } catch (error) {
    //         console.log('rxjs', 'Channel Unsubscribed')
    //     }
    // }

    // fetchActive = async (query) => {
    //     this.detailInactiveChannel.next({status: apiResponse.LOADING})
    //     try {
    //         await this.repository.fetchActive(query).then((result) => {
    //             this.detailInactiveChannel.next({status: apiResponse.COMPLETED, data: result})
    //         }).catch((error) => {
    //             this.detailInactiveChannel.next({status: apiResponse.ERROR, data: error})
    //         })           
    //     } catch (error) {
    //         console.log('rxjs', 'Channel Unsubscribed')
    //     }
    // }
}

export default DetailDataTableBloc